import { render, staticRenderFns } from "./EditorType.vue?vue&type=template&id=68b1142b&"
import script from "./EditorType.vue?vue&type=script&lang=js&"
export * from "./EditorType.vue?vue&type=script&lang=js&"
import style0 from "./EditorType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports